import { useFeatureFlags } from '@context/launch-darkly/LDProvider';

import { useProductDetailContext } from '../../ProductDetailContext';

import { IConditionalVoucherDiscount } from './ConditionalVoucherDiscount';
import { IVoucherDiscount } from './VoucherDiscount';

export const useResolvedVoucherDiscount = ():
  | IVoucherDiscount
  | IConditionalVoucherDiscount
  | null => {
  const { currentVariant } = useProductDetailContext();
  const { conditionalVoucherDiscount: conditionalVoucherDiscountEnabled } =
    useFeatureFlags();

  if (currentVariant.attributes.VoucherDiscount) {
    return currentVariant.attributes.VoucherDiscount;
  }

  const conditionalVoucherDiscount = currentVariant.attributes
    .ConditionalVoucherDiscount as IConditionalVoucherDiscount | undefined;

  if (
    conditionalVoucherDiscountEnabled &&
    conditionalVoucherDiscount &&
    conditionalVoucherDiscount.discountConditions.length === 1
  ) {
    return conditionalVoucherDiscount;
  }

  return null;
};
